<template>
	<v-menu
		v-model="menu"
		class="combo-auto-complete-search-api"
		nudge-top="16"
		open-on-click
		:close-on-content-click="false"
		transition="scale-transition"
		offset-y
		open-delay="50"
	>
		<template #activator="{ on, attrs }">
			<v-text-field
				v-bind="attrs"
				ref="comboAutoCompleteSearchApi"
				v-validate="validate"
				:name="name"
				class="pt-0"
				:placeholder="placeholder"
				dense
				clearable
				:value="itemSelected"
				readonly
				:error-messages="errors.collect(getFieldErrorsMessage)"
				:disabled="disabled"
				v-on="on"
				@click="treatMenu"
				@click:clear="clearSelectedItem"
			>
			</v-text-field>
		</template>
		<v-card tile elevation="0" class="az-form-content ma-0 pa-0">
			<v-card-title>
    <v-text-field
                    ref="comboAutoCompleteSearchApiInput"
                    v-model="search"
                    :placeholder="placeholderSearch"
                    class="pt-0"
                    dense
                    clearable
                    :loading="loading"
                    hide-details
                    @input="onSearchInput"
                    @keydown.down="handleKeyDown"
                    @keydown.up="handleKeyUp"
                    @click:clear="clearFilterSearch()"
                >
                    <template #append>
                        <v-icon class="mr-2 mt-1" color="#0067a5" size="18">mdi-magnify</v-icon>
                    </template>
                </v-text-field>
			</v-card-title>
			<v-divider></v-divider>
   <v-card-text class="pa-0 search-api-result" ref="scrollArea" @scroll.passive="onScroll">
                <div ref="listResults">
                    <v-list dense :style="getAutoCompleteWidth()">
                        <v-list-tile v-for="item in items" :key="item[itemValue]" @click="selectItem(item)">
                            <slot v-bind="{ item }" name="itemText">
                                <v-list-tile-sub-title>{{ item[itemText] }}</v-list-tile-sub-title>
                            </slot>
                        </v-list-tile>
                        <v-list-tile v-if="!items.length">
                            <slot name="noDataText">
                                <v-list-tile-sub-title>{{ noDataText }}</v-list-tile-sub-title>
                            </slot>
                        </v-list-tile>
                        <template v-if="showAction">
                            <v-divider></v-divider>
                        </template>
                    </v-list>
                </div>
            </v-card-text>
		</v-card>
	</v-menu>
</template>

<script>

import TypeValueUtils from '../../core/utils/TypeValueUtils'

export default {
    name: 'combo-autocomplete-search-api',
    inject: ['$validator'],
    props: {
        disabled: {
            type: Boolean,
        },
        items: {
            type: Array,
            default() {
                return []
            },
        },
        itemText: {
            type: String,
            required: true,
        },
        itemValue: {
            type: String,
            required: true,
        },
        loading: {
            type: Boolean,
        },
        name: {
            type: String,
            required: true,
        },
        noDataText: {
            type: String,
            default: 'Não há dados disponíveis',
        },
        placeholder: {
            type: String,
            default: 'Selecione',
        },
        placeholderSearch: {
            type: String,
            default: 'Informe o contéudo da busca',
        },
        returnObject: {
            type: Boolean,
        },
        scopeForm: {
            type: String,
            default: null,
        },
        showAction: {
            type: Boolean,
        },
        validate: {
            type: Object,
            default() {
                return {}
            },
        },
        value: {
            type: [Object, String, Number],
            default() {
                return null
            },
        },
        hasMore: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            itemSelected: null,
            menu: false,
            search: null,
            debounceTimer: null,
        }
    },
    computed: {
        getFieldErrorsMessage() {
            return this.scopeForm ? `${this.scopeForm}.${this.name}` : this.name
        },
    },
    watch: {
        menu(newValue) {
            if (newValue) {
                this.setFocusSearch()
                return
            }

            this.clearSearchInClose()
        },
        value: {
            deep: true,
            immediate: true,
            handler() {
                this.setSelectedItem()
            },
        },
    },
    beforeDestroy() {
        if (this.debounceTimer) clearTimeout(this.debounceTimer)
    },
    methods: {
        clearFilterSearch(search = null) {
            this.$emit('clear-search', search)
        },
        onSearchInput() {
            if (this.debounceTimer) clearTimeout(this.debounceTimer)
            this.debounceTimer = setTimeout(() => {
                this.filterSearch()
            }, 300)
        },
        clearSearchInClose() {
            this.resetSearch()
            this.$emit('clear-search', this.search)
        },
        clearSelectedItem() {
            this.emitInput(null)
        },
        clickAction() {
            this.$emit('click-action')
            this.treatMenu()
            this.setFocusSelectedItem()
        },
        emitInput(value) {
            this.$emit('input', value)
        },
        emitSelectedItem(item) {
            if (this.returnObject) {
                this.emitInput(item)
            } else {
                this.emitInput(item[this.itemValue])
            }
        },
        filterSearch() {
            if (this.search && this.search.trim().length > 0) {
                this.$emit('filter-search', this.search)
            } else {
                this.clearFilterSearch(this.search)
            }
        },
        getAutoCompleteWidth() {
            if (this.$refs.comboAutoCompleteSearchApi && this.$refs.comboAutoCompleteSearchApi.$el) {
                return {
                    width: this.$refs.comboAutoCompleteSearchApi.$el.clientWidth + 'px',
                }
            }
            return {}
        },
        handleKeyDown() {
            this.setPositionScrollToNavigationKey()
        },
        handleKeyUp() {
            this.setPositionScrollToNavigationKey()
        },
        onScroll() {
            const el = this.$refs.scrollArea
            if (!el || this.loading || !this.hasMore) return
            const threshold = 24
            const reachedBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - threshold
            if (reachedBottom && this.search && this.search.trim().length > 0) {
                this.$emit('load-more', this.search)
            }
        },
        resetSearch() {
            this.search = null
        },
        resetValidationField() {
            const matchOptions = {
                name: this.name,
                scope: this.scopeForm,
            }
            const field = this.$validator.fields.find(matchOptions)
            this.$nextTick(() => {
                field.reset()
                this.$validator.errors.remove(field.name, field.scope)
            })
        },
        setFocusSearch() {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.$refs.comboAutoCompleteSearchApiInput && this.$refs.comboAutoCompleteSearchApiInput.focus()
                }, 50)
            })
        },
        setFocusSelectedItem() {
            this.$refs.comboAutoCompleteSearchApi && this.$refs.comboAutoCompleteSearchApi.focus()
        },
        setPositionScrollToNavigationKey() {
            setTimeout(() => {
                const list = this.$refs.listResults
                if (!list) return
                const selectedElement = list.querySelector('.v-list-tile.v-list-tile--highlighted')
                if (selectedElement) {
                    this.setScrollIntoView(selectedElement)
                }
            }, 50)
        },
        setScrollIntoView(element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
        },
        selectItem(item) {
            this.emitSelectedItem(item)
            this.resetValidationField()
            this.resetSearch()
            this.treatMenu()
            this.resetSearch()
            this.clearSearchInClose()
            this.setFocusSelectedItem()
        },
        setSelectedItem() {
            if (!this.value) {
                this.itemSelected = null
            } else if (TypeValueUtils.isString(this.value) || TypeValueUtils.isNumber(this.value)) {
                this.itemSelected = this.value
            } else {
                this.itemSelected = this.value[this.itemText]
            }
        },
        treatMenu() {
            this.menu = !this.menu
        },
    },
}
</script>

<style lang="stylus" scoped>
.search-api-result
	max-height 304px !important
	overflow overlay !important
</style>
